import styled, { css } from 'styled-components';

export const Nav = styled.div.withConfig({
    shouldForwardProp: (prop) => !['type'].includes(prop),
})<{ type: string }>`
    display: flex;
    flex-direction: column;
    padding: 0;

    ${({ type }) =>
        type === 'sidebar' &&
        css`
            margin-top: 40px;
        `}
    h3 {
        padding: 10px 0 0;
        text-align: center;
        display: flex;
        justify-content: center;

        ${({ theme }) => theme.media.md`
            padding: 0;
            justify-content: flex-start;
        `}
    }
`;

export const Items = styled.ul.withConfig({
    shouldForwardProp: (prop) => !['type', 'orientation'].includes(prop),
})<{ type: MenuTypes; orientation: string }>`
    display: flex;
    list-style: none;
    flex-direction: ${({ orientation }) => orientation || 'column'};
    margin-block-start: 0;
    padding-inline-start: 0;
    margin: 0;

    ${({ type }) =>
        type === 'sidebar' &&
        css`
            gap: 15px;
        `}
    li {
        padding: ${({ orientation }) => (orientation === 'column' ? '4px 0' : '0 10px')};
        text-align: ${({ theme, type }) => theme.align.nav[type].mobile};

        ${({ theme, type }) => theme.media.md`
           text-align: ${theme.align.nav[type].tablet};
        `}
        ${({ theme, type }) => theme.media.md`
           text-align: ${theme.align.nav[type].desktop};
        `}
        a.active > span,
        a:active > span,
        a:hover > span {
            color: ${({ theme }) => theme.colors.secondary.secondary50};
        }
    }
`;

export const DropdownSelector = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding-top: 3px;
`;

export const DropdownItem = styled.li`
    display: flex;
    align-items: center;
    padding: 10px 25px;
    white-space: nowrap;

    &:hover {
        background: ${({ theme }) => theme.colors.neutral.neutral96};
    }

    a {
        display: flex;
        align-items: center;
        padding: 10px 20px;
    }
`;

export const DropdownContainer = styled.ul`
    list-style: none;
    padding-inline-start: 0;
    margin: 0;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
`;
